import React from 'react'

export interface Config {
  sliderWidth?: number
  openPageX?: number
  touchTolerance?: number
  toggleThreshold?: number
  widthDebounce?: number
  defaultIsOpen?: boolean
  enable?: boolean
}

export interface SliderState {
  isOpen: boolean
  isSliding: boolean
  dragStarted: boolean
  dragWidth: number
  sliderStyle: React.CSSProperties
}

export enum ActionTypes {
  TOGGLE = 'TOGGLE',
  TOUCHSTART = 'TOUCHSTART',
  TOUCHMOVE = 'TOUCHMOVE',
  TOUCHEND = 'TOUCHEND',
}
